import { observer } from "mobx-react-lite";
import React, { useContext, useRef, useEffect, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  url: string;
  className?: string;
}

const ProtectedImage: React.FC<IParams> = ({ url, className }) => {
  const rootStore = useContext(RootStoreContext);
  
  const { loadProtectedThumbImageOrVideo } = rootStore.meetingStore;
  const [srcData, setSrcData] = useState("");
  const imgRef = useRef<HTMLImageElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
   //lazy loading
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Una volta che l'immagine è visibile, non abbiamo più bisogno di osservarla
          if (imgRef.current) {
            observer.unobserve(imgRef.current);
          }
        }
      });
    });
 
    if (imgRef.current) {
      observer.observe(imgRef.current);
    }
 
    // Cleanup
    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, []);


  useEffect(() => {
    let isMounted = true; // Aggiungi una variabile per controllare se il componente è montato
   
    if (isVisible) {//lazy loading
      loadProtectedThumbImageOrVideo(url).then((res) => {
        if (res && res.data && isMounted) { // Controlla se il componente è ancora montato
          const objectURL = URL.createObjectURL(res.data);
          setSrcData(objectURL);
        }
      }).catch(error => {
        console.error("Error loading protected image or video:", error);
        // Optionally, handle the error by updating the component state or logging
      });
    }
  
    return () => {
      isMounted = false; // Imposta isMounted a false quando il componente viene smontato
     
      /* if (srcData) {
        URL.revokeObjectURL(srcData); // Revoca l'URL dell'oggetto qui
      } */
    };
  }, [url, loadProtectedThumbImageOrVideo, isVisible]); // Aggiungi srcData alle dipendenze per revocare l'URL correttamente

  return <img ref={imgRef} src={isVisible ? srcData : undefined} alt="" className={className} />;
 
};

export default observer(ProtectedImage);
